import React from "react"

import { SearchState } from "react-instantsearch-core"
import { CurrentRefinementsProvided } from "react-instantsearch-core"
import { connectCurrentRefinements } from "react-instantsearch-dom"
import { useIntl } from "react-intl"

import { getFilterNumber } from "../../utils/getFilterNumber"
import { Button } from "~/components/ui/Button/Button"

type propType = CurrentRefinementsProvided & {
  searchState: SearchState
}

const ClearRefinements = ({ items, refine, searchState }: propType) => {
  const intl = useIntl()
  return (
    <Button
      onClick={() => refine(items)}
      disabled={!items.length}
      variant="secondary"
      color="original"
    >
      {intl.formatMessage({
        id: "category/button:clear",
      })}{" "}
      ({getFilterNumber({ searchState: searchState })})
    </Button>
  )
}

const CustomClearRefinements =
  connectCurrentRefinements<propType>(ClearRefinements)

export default CustomClearRefinements
